// Catálogo dos serviços externos que o navegador alcança direto, espelhando o
// payload de GET /external_services (em camelCase, como os interceptors
// entregam).
//
// A fonte de verdade em runtime é o endpoint. Esta constante é o ponto de
// partida e a rede de segurança quando ele não responde, e a única fonte
// possível do timeout em service/api.js, que cria as instâncias do axios na
// carga do módulo — antes de existir sessão para buscar o catálogo remoto.

// Estados observados pelo navegador. Nunca vêm do servidor.
//
// `unverifiable` é para serviço sem probePath: não dá para medir, e declarar
// inalcançável seria afirmar o que não se mediu — fecharia o gate e mostraria
// alerta de bloqueio sem haver bloqueio. Só `unreachable` fecha gate.
const REACHABILITY = {
  CHECKING: 'checking',
  REACHABLE: 'reachable',
  UNREACHABLE: 'unreachable',
  UNVERIFIABLE: 'unverifiable',
}

// Como as telas endereçam um serviço.
const COOKIES_KEY = 'cookies'

const DEFAULT_TIMEOUT_MS = 30000

// Só os campos que o front precisa para funcionar ANTES e SEM a resposta da
// API. Os descritivos (label, accessMode, impact, domainOwner, upstreamStatus)
// chegam na mesclagem e não são lidos aqui — declará-los seria duplicar o
// contrato sem ganho.
//
// `projectTag` é o único que não vem da API: liga a entrada ao tag do
// api.create, e é como service/api.js encontra o timeout na carga do módulo.
const DEFAULT_ENTRY = {
  projectTag: null,
  probePath: null,
  timeoutMs: DEFAULT_TIMEOUT_MS,
}

// `dponet` não entra: é dependência implícita de tudo e, se estiver fora, o
// usuário nem chegou a logar.
const CATALOG = {
  [COOKIES_KEY]: {
    ...DEFAULT_ENTRY,
    projectTag: 'cookies',
    probePath: '/up',
  },
  marketPlace: {
    ...DEFAULT_ENTRY,
    projectTag: 'marketPlace',
  },
  trainingPortal: {
    ...DEFAULT_ENTRY,
    projectTag: 'trainingPortal',
  },
}

const externalServices = {
  CATALOG,
  COOKIES_KEY,
  REACHABILITY,
  ALERT_TITLE: 'Não foi possível conectar ao serviço.',
  ALERT_ACTION_LABEL: 'Tentar novamente',
  alertMessage: (hosts) =>
    `A rede que você está usando parece estar bloqueando o acesso a ${hosts}. ` +
    'Isso costuma ser uma regra de firewall ou proxy corporativo. Peça ao time ' +
    'de TI da sua empresa para liberar esse acesso e tente novamente.',
}

export default externalServices
